import { CModalHeader } from "@coreui/react";
import StyledModal from "src/components/BasicModal/BasicModal.style";
import PostValidation from "./PostValidation";
import PreValidation from "./PreValidation";
import SelfAssessment from "./SelfAssessment";
import ContactForm from "../ContactForm";

const WhatsNextModal = ({ track, show, onClose, isVerified }) => {
  return (
    <StyledModal size="lg" show={show} onClose={onClose} centered>
      <div className="px-4 py-4">
        <CModalHeader closeButton>
          <h3 style={{ fontSize: "28px" }}>What's Next?</h3>
        </CModalHeader>
        {isVerified ? (
          <PostValidation />
        ) : track === "self-assessment" ? (
          <SelfAssessment onClose={onClose} />
        ) : (
          <PreValidation />
        )}
        <ContactForm />
      </div>
    </StyledModal>
  );
};

export default WhatsNextModal;
